module.exports = __webpack_public_path__ + "static/assets/9be09138e4f07309ccfa9aa34e00e421.svg";